<template>
  <div class="congestion-card-item">
    <div class="card-item-title">最堵{{ cardData.cardName }}</div>
    <div class="card-item-info">
      <span class="card-item-area">{{ cardData.cardArea }}</span>
      <span
        v-if="cardData.desc"
        class="card-item-state"
        :style="{ color: cardData.color, background: cardData.bgColor }"
      >
        {{ cardData.desc }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'CongestionCard',
  components: {},
  props: {
    cardData: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../common/css/common-mixin";

.congestion-card-item {
  padding: rpx(10) 0;
  .card-item {
    &-title {
      margin-bottom: rpx(2);
      font-size: rpx(24);
      color: rgba(0, 0, 0, 0.6);
    }
    &-info {
      display: flex;
      align-items: center;
    }
    &-area {
      display: inline-block;
      padding: 0 rpx(8) 0 0;
      font-size: rpx(28);
      color: rgba(0, 0, 0, 0.9);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: rpx(194);
    }
    &-state {
      padding: rpx(4) rpx(6);
      font-size: rpx(20);
      line-height: rpx(20);
      border-radius: rpx(4);
    }
  }
}
</style>
